/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Two_Fa_VerifyInputs */

const en_two_fa_verify = /** @type {(inputs: Two_Fa_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verify`)
};

const nl_two_fa_verify = /** @type {(inputs: Two_Fa_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifiëren`)
};

/**
* | output |
* | --- |
* | "Verify" |
*
* @param {Two_Fa_VerifyInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const two_fa_verify = /** @type {((inputs?: Two_Fa_VerifyInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Two_Fa_VerifyInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_two_fa_verify(inputs)
	return en_two_fa_verify(inputs)
});